import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/account/')({
  beforeLoad: () => {
    throw redirect({ to: '/clearing/operations/account/correspondent' });
  },
  preload: false,
  // staticData: {
  //   tab: {
  //     group: TabbedNavigationGroup.ClearingOperationsPlatformAccount,
  //     label: 'Firm',
  //     order: 0,
  //   },
  // } satisfies PortalTabbedNavigationTab<TabbedNavigationGroup.ClearingOperationsPlatformAccount>,
  // loader: () =>
  //   ({
  //     breadcrumb: buildBreadcrumb({
  //       id: 'firm-account-list',
  //       label: 'Firm & Correspondent Accounts',
  //       to: '/clearing/operations/account',
  //     }),
  //   }) satisfies AggregateBreadcrumb,
  // head: () => getPageHead('Firm Accounts'),
  // component: FirmAccountList,
});

// const firmAccountQuery: IxcRegistrationV1AccountQueryServiceAccountListAccountListRequest = {
//   query: {
//     filters: [
//       {
//         field: {
//           name: IxcRegistrationV1AccountQueryServiceAccountListFilterableFields.DataSpecType,
//           type: {
//             value: 'platform',
//           },
//         },
//       },
//       {
//         field: {
//           name: IxcRegistrationV1AccountQueryServiceAccountListFilterableFields.DataAccountingGroup,
//           type: {
//             value: IxcRegistrationV1AccountingGroup.Firm,
//           },
//         },
//       },
//     ],
//   },
// };

// const columns = { md: 2 } as const;

// function FirmAccountList() {
//   return (
//     <PageLayout maxWidthContainer={DEFAULT_PAGE_LAYOUT_MAX_WIDTH_CONTAINER_SIZE}>
//       <PageLayout.Section noBorder>
//         <VerticalStack gap={7}>
//           <PageTabRail
//             actions={
//               <FirmAccountDescriptionDrawer
//                 query={firmAccountQuery}
//                 trigger={
//                   <PlainIconButton aria-label="View more information about firm accounts">
//                     <InfoIcon aria-hidden width={16} />
//                   </PlainIconButton>
//                 }
//               />
//             }
//             group={TabbedNavigationGroup.ClearingOperationsPlatformAccount}
//             stackAlign="start"
//           />

//           <PlatformAccountTileGrid columns={columns} loadingTiles={4} query={firmAccountQuery} />
//         </VerticalStack>
//       </PageLayout.Section>
//     </PageLayout>
//   );
// }
